(function ($, ko) {
    var faqModel = function(updateHeight) {
        this.mini = ko.observable(false);
        this.faq = new $.cdh.get.resources.faq();

        // load faq will fail when the user is not logged & default user id is NULL
        // then redirect to login page
        this.faq.load()
                .fail(function (response) {       
                    $("#faq-content").hide();
                    // un-authorized status code set in action filter
                    window.location.href = $.cdh.routes.authentication.handshake();
                });
        this.faq.state.subscribe(updateHeight);

        this.afterRender = function () {
            var item = $(".faq-item .title");
            item.prop('onclick', null).off('click');
            item.off('keypress');
            item.click(function () {
                toggleItem(this);
            });
            item.keypress(function (event) {
                if (event.keyCode === 13 || event.keyCode === 32) {
                    toggleItem(this);
                    return false;
                }
            });
            function toggleItem(faq) {
                $(faq).attr('aria-expanded', $(faq).attr('aria-expanded') === 'false' ? 'true' : 'false');
                $(faq).parent('.faq-item').toggleClass('open');
                updateHeight();
                recalcWidgetsHeights();
            };

            $.cdh.helper.setAllVideoIframesRatio();
            recalcWidgetsHeights();
        };
    };

    ko.components.register('faq', {
        template: { element: 'template-resources-faq' },
        viewModel: {
            createViewModel: function (params, componentInfo) {
                var updateHeight = updateContainerHeight(componentInfo.element);
                return new faqModel(updateHeight);
            }
        }
    });
})(jQuery, ko);
 